import styles from "./DebtDisclosureRequiredModal.module.css";
import WarningModal from "../common/modals/WarningModal/WarningModal";

const strings = {
  debtDisclosureModalLabel: "Debt Disclosure Required Modal",
  debtDisclosureWarningCode: "Error A_0378",
  debtDisclosureMustComplete:
    "Debt Disclosure page must be completed prior to Completing the Call on the Result page or starting New Search.",
  debtDisclosureInstructions: "Select Yes or No, then click the Submit button.",
  debtDisclosureButtonText: "Go to Debt Disclosure",
};

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
};

export default function DebtDisclosureRequiredModal({
  isOpen,
  onRequestClose,
}: Props) {
  return (
    <WarningModal
      isOpen={isOpen}
      modalLabel={strings.debtDisclosureModalLabel}
      body={
        <>
          <div className={styles.debtDisclosureWarningCode}>
            {strings.debtDisclosureWarningCode}
          </div>
          <div className={styles.debtDisclosureMustComplete}>
            {strings.debtDisclosureMustComplete}
          </div>
          <div>{strings.debtDisclosureInstructions}</div>
        </>
      }
      closeText={strings.debtDisclosureButtonText}
      onRequestClose={onRequestClose}
    />
  );
}
